import { FormGroup, Label, Input } from "reactstrap";

function DishwasherDropdown(props) {
  return (
    <FormGroup>
      <Label for={props.name}>{props.title}</Label>
      <Input
        value={props.value}
        onChange={(e) => props.setValue(e.target.value)}
        required
        type="select"
        name={props.name}
        id={props.name}
        placeholder={props.title}
      >
        <option>Please Select</option>
        {props.allow60cm ? <option>60cm-Full Size</option> : null} 
        {props.allow45cm ? <option>45cm-Slim Line</option> : null} 
        <option>No</option>
      </Input>
    </FormGroup>
  );
}

export default DishwasherDropdown;
